// The one money icon (gold coin, 1:1). `size` is the diameter in px.
// coinSvgMarkup is the same coin as a string for the fx layer (payment flights).
const RIM = "#B07D1E";
const FACE = "#E6B43C";
const INNER = "#F2CC63";
const MARK = "#9A6A12";

function coinBody() {
  return `<circle cx="12" cy="12" r="11" fill="${FACE}" stroke="${RIM}" stroke-width="1.5"/>`
    + `<circle cx="12" cy="12" r="7.6" fill="${INNER}" stroke="${RIM}" stroke-width="0.9" opacity="0.95"/>`
    + `<path d="M12 7.6v8.8M9.6 9.8c0-1.1 1.1-1.7 2.4-1.7s2.4.6 2.4 1.6c0 2.3-4.8 1.3-4.8 3.7 0 1 1.1 1.7 2.4 1.7s2.4-.6 2.4-1.7" fill="none" stroke="${MARK}" stroke-width="1.35" stroke-linecap="round"/>`
    + `<path d="M5.4 8.2A7.6 7.6 0 0 1 9 5" fill="none" stroke="#FFFFFF" stroke-width="1.1" stroke-linecap="round" opacity="0.6"/>`;
}

export function coinSvgMarkup(size) {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${size}" height="${size}" aria-hidden="true" style="display:block">${coinBody()}</svg>`;
}

export default function Coin({ size = 16, standalone = false, testid }) {
  const a11y = standalone ? { role: "img", "aria-label": "money" } : { "aria-hidden": true };
  return (
    <span data-coin="gold" data-testid={testid} className="inline-flex shrink-0" {...a11y}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        style={{ display: "block", flexShrink: 0 }}
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: coinBody() }}
      />
    </span>
  );
}
